import { Link } from 'react-router-dom';
import Logo from '../Logo/Logo.js';
import SalesPhone from '../SalesPhone/SalesPhone.jsx';
import { FaPhone } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';
import {
  EMAIL,
  EMAIL_HREF,
  FOOTER_ADDRESSES,
  PHONE_DISPLAY,
  PHONE_HREF,
  STRELETS_EMAIL,
  STRELETS_EMAIL_HREF,
} from '../../constants/contactInfo.js';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__container-top">
          <div className="footer__contacts">
            <a href={PHONE_HREF} className="footer__phone" target="_blanck">
              <FaPhone /> {PHONE_DISPLAY}
            </a>
            <SalesPhone className="footer__phone" />
            <a
              href={EMAIL_HREF}
              className="footer__email"
              target="_blanck"
            >
              <FaEnvelope /> {EMAIL}
            </a>
            <a
              href={STRELETS_EMAIL_HREF}
              className="footer__email"
              target="_blanck"
            >
              <FaEnvelope /> {STRELETS_EMAIL}
            </a>
          </div>
          <div className="footer__address">
            <div className="footer__address-content">
              <div className="footer__address-heading">
                <FaMapMarkerAlt className="footer__address-icon" />
                <span className="footer__address-title">Адреса</span>
              </div>
              <div className="footer__address-list">
                {FOOTER_ADDRESSES.map((address) => (
                  <div key={address.text} className="footer__address-item">
                    <span className="footer__address-badge">{address.label}</span>
                    <span className="footer__address-text">{address.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="footer__socials" aria-label="Социальные сети">
            <a
              href="https://vk.ru/id607995315"
              className="footer__social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="ВКонтакте"
            >
              <img
                src="/images/socials/VK.svg.webp"
                alt=""
                className="footer__social-icon"
              />
            </a>
            <a
              href="https://max.ru/join/yLUnVZOKZLgNUSNxL91fDeSqhEm7MK9yCIMvaGrlODE"
              className="footer__social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="MAX"
            >
              <img
                src="/images/socials/MAX.svg.webp"
                alt=""
                className="footer__social-icon"
              />
            </a>
          </div>
        </div>
        <div className="footer__container-bottom">
          <div className="footer__meta">
            <p className="footer__copyright">
              © {new Date().getFullYear()} СОО ВДПО. Все права защищены.
            </p>
            <div className="footer__legal">
              <Link to="/privacy-policy/" className="footer__legal-link">
                Политика обработки персональных данных
              </Link>
              <Link to="/personal-data-consent/" className="footer__legal-link">
                Согласие на обработку персональных данных
              </Link>
              <Link to="/cookies-policy/" className="footer__legal-link">
                Файлы cookie и технические данные
              </Link>
            </div>
          </div>
          <div className="footer__logo-wrap">
            <Logo />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
